import styled from "styled-components";

export const ImportOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  gap: 1rem;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
`;

export const Wrapper = styled.div`
  margin-top: 0.5rem;
  @media only screen and (max-width: 1100px) {
    .max-screen {
      display: none;
    }

    .min-screen {
      label > .label {
        text-align: left;
        margin-right: 0.5rem;
        font-size: 11px;
        font-weight: normal;
      }
    }
  }

  @media only screen and (min-width: 1100px) {
    .max-screen {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      column-gap: 1.2rem;

      .value-label {
        display: grid;
        grid-template-columns: 1fr 1fr;

        .flex {
          display: flex;
        }
      }

      .initial-value {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }

      .final_value {
        input {
          width: 110px;
        }
      }
      label > .label {
        text-align: right;
        margin-right: 0.5rem;
        font-size: 11px;
        font-weight: normal;
      }
    }

    .min-screen {
      display: none;
    }
  }

  label {
    display: grid;
    grid-template-columns: 1fr 3fr;

    @media only screen and (max-width: 600px) {
      grid-template-columns: 1fr;

      .label {
        display: none;
      }
    }
  }

  .wrapper-date {
    display: grid;
    grid-template-columns: 1fr;
  }
`;

export const ImportSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media only screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }

  .card {
    border-radius: 8px;
    padding: 0.75rem;
    text-align: center;
    border: 1px solid transparent;

    strong {
      display: block;
      font-size: 24px;
      line-height: 1.2;
    }

    span {
      font-size: 13px;
    }
  }

  .success {
    background: #e8fff3;
    border-color: #50cd89;
    color: #1b7a47;
  }

  .info {
    background: #e8f4ff;
    border-color: #0095e8;
    color: #005f94;
  }

  .danger {
    background: #fff5f8;
    border-color: #f1416c;
    color: #b0173e;
  }
`;

export const ImportSection = styled.div`
  margin-bottom: 1rem;
`;

export const ImportNotice = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  border-radius: 8px;
  padding: 0.85rem 1rem;
  margin-bottom: 0.75rem;
  font-size: 14px;
  border-left: 5px solid;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }

  strong {
    display: block;
    font-size: 15px;
    margin-bottom: 0.25rem;
  }

  p {
    margin: 0.25rem 0 0;
  }

  ol {
    margin: 0.25rem 0 0.25rem 1.1rem;
    padding: 0;
  }

  &.warning {
    background: #fff8dd;
    border-color: #ffc700;
    color: #6b5200;
    svg { color: #e0a800; }
  }

  &.tip {
    background: #e8f4ff;
    border-color: #0095e8;
    color: #00436b;
    svg { color: #0095e8; }
  }

  &.danger {
    background: #fff5f8;
    border-color: #f1416c;
    color: #8a1230;
    svg { color: #f1416c; }
  }

  &.success {
    background: #e8fff3;
    border-color: #50cd89;
    color: #1b7a47;
    svg { color: #50cd89; }
  }
`;

export const ImportTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    border: 1px solid #e4e6ef;
    padding: 0.4rem 0.6rem;
    text-align: left;
  }

  th {
    background: #f5f8fa;
    font-weight: 600;
  }

  .mono {
    font-family: Consolas, 'Courier New', monospace;
    word-break: break-all;
  }
`;
